import { IOrganizationDto } from './dtos'
import { IOrganization } from './models'

export const mapOrganizationFromDto = ({ id, credits, email, name, isAdmin }: IOrganizationDto): IOrganization => ({
	id,
	credits,
	email,
	name,
	isAdmin,
})
